import { Controller } from "@hotwired/stimulus";

// Clicks its trigger target as soon as it's connected, then strips the
// triggering query param from the URL so a refresh doesn't repeat it.
export default class extends Controller {
  static targets = ["trigger"];
  static values = { param: String };

  connect() {
    this.triggerTarget.click();
    const url = new URL(window.location.href);
    url.searchParams.delete(this.paramValue);
    window.history.replaceState(null, "", url);
  }
}
